import { render, staticRenderFns } from "./addListaPrice.vue?vue&type=template&id=8577916a"
import script from "./addListaPrice.vue?vue&type=script&lang=js"
export * from "./addListaPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports